import React from 'react';
import PropTypes from 'prop-types';

// Redesenho vetorial da marca Marcelo Manhães (os PNGs em public/img têm só
// 500-700px e ficam pixelados em tela cheia). Mesma geometria da marca: dois
// picos prateados em traço grosso e o "M" dourado formado por dois picos menores.
export function PicosManhaes({ className, idPrefixo }) {
  const prata = `${idPrefixo}-prata`;
  const ouro = `${idPrefixo}-ouro`;
  return (
    <svg
      className={className}
      viewBox="0 0 700 300"
      preserveAspectRatio="xMidYMax meet"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={prata} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#3B4048" />
          <stop offset="0.42" stopColor="#F4F6F8" />
          <stop offset="0.62" stopColor="#9AA0A8" />
          <stop offset="1" stopColor="#2A2E35" />
        </linearGradient>
        <linearGradient id={ouro} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#A87B27" />
          <stop offset="0.5" stopColor="#F1DDAE" />
          <stop offset="1" stopColor="#C99A3B" />
        </linearGradient>
      </defs>
      <g fill="none" strokeLinejoin="miter" strokeLinecap="butt" strokeMiterlimit="10">
        <polyline points="58,300 300,46 382,134" stroke={`url(#${prata})`} strokeWidth="54" />
        <polyline points="214,300 444,58 548,188" stroke={`url(#${prata})`} strokeWidth="54" />
        <polyline
          points="330,300 438,178 492,240 556,170 664,300"
          stroke={`url(#${ouro})`}
          strokeWidth="46"
        />
      </g>
    </svg>
  );
}

PicosManhaes.propTypes = {
  className: PropTypes.string,
  idPrefixo: PropTypes.string,
};

PicosManhaes.defaultProps = {
  className: '',
  idPrefixo: 'picos',
};

export function NomeManhaes({ className }) {
  return (
    <p className={className}>
      <span className="manhaes-nome-marcelo">Marcelo</span>
      {' '}
      <span className="manhaes-nome-sobrenome">Manhães</span>
      <span className="manhaes-nome-ramo">Assessoria Previdenciária</span>
    </p>
  );
}

NomeManhaes.propTypes = {
  className: PropTypes.string,
};

NomeManhaes.defaultProps = {
  className: '',
};
